import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const DepositWrapper = styled('div', { label: 'DepositWrapper' })<{ isSignup: boolean }>`
    min-height: ${({ isSignup }): string => (isSignup === true ? 'calc(100vh - 256px)' : '100vh')};
    position: relative;
`;

export const Content = styled('div', { label: 'Content' })`
    padding: 16px;
`;

export const SectionCaption = withConfig(theme => styled('p', { label: 'SectionCaption' })<{ isSignup?: boolean }>`
    font-weight: ${theme.star.fontWeight.regular};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.25;
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.txtColor : 'inherit')};
    margin: 0 0 24px 0;
`);

export const PaymentMethodContainer = styled('div', { label: 'PaymentMethodContainer' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const PaymentMethodOption = withConfig(theme => styled('label', { label: 'PaymentMethodOption' })<{ isSignup: boolean }>`
    min-width: 343px;
    width: fit-content;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    cursor: pointer;
    border-radius: 4px;
    background: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.bgColorSecondary : theme.star.multiDeposit.bgColor)};
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.txtColor : theme.star.multiDeposit.txtColor)};
    opacity: 1;
    box-sizing: border-box;
`);

export const BankLogos = styled('div', { label: 'BankLogos' })`
    display: flex;
    gap: 2px;
    margin-top: 4px;
`;

export const PaymentMethodInfo = styled('div', { label: 'PaymentMethodInfo' })`
    min-width: 220px;
    flex: 1;
    display: flex;
    flex-direction: column;
    opacity: 1;
    
    > *:first-of-type {
        margin-bottom: 4px;
    }
    
    > *:nth-of-type(2) {
        margin-bottom: 8px;
    }
`;

export const PaymentMethodTitle = withConfig(theme => styled('div', { label: 'PaymentMethodTitle' })<{ isSignup: boolean }>`
    font-weight: ${theme.star.fontWeight.bold};
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.5;
    letter-spacing: 0;
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.txtColor : 'inherit')};
`);

export const PaymentMethodDescription = withConfig(theme => styled('div', { label: 'PaymentMethodDescription' })<{ isSignup: boolean }>`
    font-weight: ${theme.star.fontWeight.regular};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.25;
    letter-spacing: 0;
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.footer.txtColor : theme.star.multiDeposit.txtColorSecondary)};
`);

export const RadioWrapper = styled('div', { label: 'RadioWrapper' })`
    margin-left: -30px;
`;
